
import { Modal } from "../Model/Modal/Modal";
import { OffersPromoRepository } from "../Repository/OffersPromoRepository";


export interface GetModalByIdUseCase {
  invoke: (id: number) => Promise<Modal | null>;
}

export class GetModalById implements GetModalByIdUseCase {
  private Repo: OffersPromoRepository;
  constructor(_Repo: OffersPromoRepository) {
    this.Repo = _Repo;
  }

   invoke(id: number){
    if(!id){
        throw new Error(
            "Your todo should have at leat 2 characters."
          );
    }
    const getData = this.Repo.getModalById(id);
    return getData;
  }
}